/* eslint-disable */
export function isEmailValid(email) {
    const filter = /^([a-zA-Z0-9_\.\-])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$/;
    return filter.test(email);
}

export function isPasswordValid(password) {
    const lowercaseRegex = /[a-z]/;
    const uppercaseRegex = /[A-Z]/;
    const numberRegex = /[0-9]/;
    const specialCharRegex = /[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]/;
    if (
        password.length < 8 ||
        !lowercaseRegex.test(password) ||
        !uppercaseRegex.test(password) ||
        !numberRegex.test(password) ||
        !specialCharRegex.test(password)
    ) {
        return false;
    }
    return true;
}

export function isPhoneNumberValid(phone) {
    return (phone.match(/\d/g) || []).length === 10;
}
